import LaporanHasilKI4 from '../../../../views/Kurikulum/Raport/Cetak/LaporanHasilKI4.view';
import { connect } from 'react-redux';
import { getStudent } from '../../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch){ 
    return{
        handleGetStudent: () => dispatch(getStudent()),
    };
}
export default connect(null, mapDispatchToProps) (LaporanHasilKI4);
